module.exports = __webpack_public_path__ + "img/img_body_biz_jeju_bank_logo.6b163a78.png";